import byField from '@hbrisk/sp3-risk-model-support/utility/form/formInputsTransforms/byField/index.js';
import clearAutofilledValues from '@hbrisk/sp3-risk-model-support/utility/form/clearAutofilledValues/index.js';

// The model write schema requires every ordinary field to carry its aiStatus/provenance marking
// (data & API design §3.1). Marking is now FORM STATE (UI design §3.4), carried in the redux-form
// slice alongside values/visible/autofilled, so accept/reject transitions are local-first and
// instant -- the marking the user just flipped is already in the form state by the time this runs,
// with no separate overlay step. For fields with no marking (aiStatus missing or undefined), default
// to 'none'/null so the payload shape is always complete.
const defaultMarking = aiStatusValue => {
  const aiStatus = aiStatusValue || 'none';
  return { aiStatus, provenance: aiStatus === 'none' ? null : undefined };
};

const calculateModelPutPayload = ({
  autofilled,
  visibleFields,
  values,
  fields,
  aiStatus: aiStatusMap = {},
  provenance: provenanceMap = {},
}) => {
  const aiStatus = {};
  const provenance = {};
  fields.forEach(({ name }) => {
    const marking = defaultMarking(aiStatusMap[name]);
    aiStatus[name] = marking.aiStatus;
    provenance[name] =
      marking.provenance !== undefined ? marking.provenance : provenanceMap[name] || null;
  });
  return {
    formInputs: byField(
      clearAutofilledValues({ autofilled, visibleFields, values, aiStatus, provenance }, fields),
      fields
    ),
  };
};

export default calculateModelPutPayload;
